<template>
  <div>
    <vehicle-information></vehicle-information>
    <nav class="menu-background sticky-top">
      <Menu class="smaller-container-wrapper" :category-list="categoryList" />
    </nav>
    <div class="spotlight-inner-wrapper px-0">
      <div class="smaller-container-wrapper mb-5">
        <h5>{{ $t(`message.spotlightV2.categories.${category}.title`) }}</h5>
        <router-view :sub-categories="subCategories"></router-view>
      </div>
      <CTA class="cta-container" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const VehicleInformation = () => import('@/modules/spotlight/components/categories/VehicleInformation.vue');
const Menu = () => import('@/modules/spotlight/components/HorizontalScrollBar.vue');
const CTA = () => import('@/components/ProductCTAs.vue');

export default {
  name: 'Categories',
  components: {
    VehicleInformation,
    CTA,
    Menu,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      categories: 'spotlight/getSpotlightCategories',
    }),
    categoryList() {
      return [
        ...this.categories.map(value => ({
          name: value.category,
          value: value.category,
        })),
      ];
    },
    category() {
      return this.$route.meta.category;
    },
    subCategories() {
      const currentCategory = this.categories.find(categoryObj => categoryObj.category === this.category);
      if (!currentCategory || currentCategory.spotlights.length === 1) {
        return null;
      }
      const spotlights = [...currentCategory.spotlights];
      return spotlights.reduce(
        (result, spotlight) => {
          const hasSubcategory = result.findIndex(item => item.value === spotlight.subcategory);

          if (hasSubcategory > -1) {
            // eslint-disable-next-line no-param-reassign
            result[hasSubcategory].count += 1;
          } else {
            result.push({
              value: spotlight.subcategory,
              count: 1,
            });
          }
          return result;
        },
        [
          {
            value: 'all',
            count: currentCategory.spotlights.length,
          },
        ]
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.menu-background {
  background: $primary;
  top: 45px;
}
.spotlight-inner-wrapper {
  .smaller-container-wrapper {
    h5 {
      margin-top: 40px;
      margin-bottom: 24px;
    }
  }
}
.cta-container {
  padding: 0 20px 100px;
}
</style>
